const Images = {
  SEO: {
    Image: '/img/rencontre-garde-chien.png',
  },
  AppAvatar: '/theme/app-avatar.png',
  Header: {
    Pattern: '/theme/header-pattern.png',
  },
  FileDropZone: {
    Borrower: '/theme/emt/file-drop-zone/borrower.png',
    Owner: '/theme/emt/file-drop-zone/dogowner.png',
    OwnerPetsitter: '/theme/emt/file-drop-zone/dogowner-petsitter.png',
    Petsitter: '/theme/emt/file-drop-zone/petsitter.svg',
    dark: {
      Borrower: '/theme/emt/file-drop-zone/dark/borrower-png',
      Owner: '/theme/emt/file-drop-zone/dark/dogowner.png',
    },
  },
  Premium: {
    UserQuote: '/theme/emt/premium/user-quote.png',
    Borrower1: '/theme/premium/buddy.png',
    Chloe: '/theme/premium/chloe.png',
    Thibault: '/theme/premium/thibault.png',
    Elodie: '/theme/premium/elodie.png',
    Raphael: '/theme/premium/raphael.png',
    Michel: '/theme/premium/michel.png',
    Success: '/theme/premium/premium-user-success.png',
  },
  Cloud1: '/theme/cloud1.png',
  Cloud2: '/theme/cloud2.png',
}

export default Images
